import './GeneratedPrompt.css';
import SaveTemplateDialog from './SaveTemplateDialog.jsx';

const GeneratedPrompt = ({ showSaveTemplateButton, showDialog, setShowDialog, promptTemplate, handlePromptChange, handleSaveTemplate }) => {
  return (
    <div className="generated-prompt-wrapper">
      <div className="generated-prompt-container">
        <div className="generated-prompt-header">
          {showSaveTemplateButton ? (
            <button className="save-template-button" onClick={() => setShowDialog(true)}>
              🖫 Save as Template
            </button>
          ) : (
            <div className="template-buttons">
              <button className="save-template-button">
                🖫 Saved
              </button>
              <button className="delete-template-button">
                🗑︎ Delete Template
              </button>
            </div>
          )}
        </div>
        <textarea
          className="generated-prompt-textarea"
          value={promptTemplate}
          onChange={handlePromptChange}
        ></textarea>
      </div>
      <span className="generated-prompt-hint">
        &#x24D8; Please do not change the &lt;PLACEHOLDERS&gt;
      </span>
      {showDialog && (
        <SaveTemplateDialog 
          onClose={() => setShowDialog(false)}
          onSave={handleSaveTemplate} 
        />
      )}
    </div>
  );
};

export default GeneratedPrompt;